import React from "react";

import { getImage, ImageType } from "../../../../helpers/imageHelper";
import { useString, useStrings } from "../../../../localization/localizationHelpers";

import { LandingCtaPlacements, useLandingCta } from "../../useLandingCta";
import * as styles from "./PartnerBuildSection.module.css";

type FeatureProps = Readonly<{
  title: string;
  description: string;
}>;

const Feature = ({ title, description }: FeatureProps) => (
  <div className={styles.feature}>
    <h3 className={styles.featureTitle}>{title}</h3>
    <p className={styles.featureDescription}>{description}</p>
  </div>
);

export const PartnerBuildSection = () => {
  const handleGetStarted = useLandingCta(LandingCtaPlacements.build);

  const [
    eyebrow,
    title,
    gdkTitle,
    gdkDescription,
    bulletServices,
    bulletApis,
    bulletMultiDevice,
    getStartedLabel,
    enginesTitle,
    enginesDescription,
    optimizeTitle,
    optimizeDescription,
  ] = useStrings(
    "landingBuildEyebrow",
    "landingBuildTitle",
    "landingBuildGdkTitle",
    "landingBuildGdkDescription",
    "landingBuildBulletServices",
    "landingBuildBulletApis",
    "landingBuildBulletMultiDevice",
    "landingHeroGetStartedButton",
    "landingBuildEnginesTitle",
    "landingBuildEnginesDescription",
    "landingBuildOptimizeTitle",
    "landingBuildOptimizeDescription"
  );

  const gdkImageAlt = useString("landingBuildGdkImageAlt");

  return (
    <section className={styles.section}>
      <div className={styles.card}>
        <header className={styles.cardHeader}>
          <span className={styles.eyebrow}>{eyebrow}</span>
          <h2 className={styles.title}>{title}</h2>
        </header>
        <div className={styles.highlight}>
          <div className={styles.highlightContent}>
            <h3 className={styles.highlightTitle}>{gdkTitle}</h3>
            <p className={styles.highlightDescription}>{gdkDescription}</p>
            <ul className={styles.bulletList}>
              <li>{bulletServices}</li>
              <li>{bulletApis}</li>
              <li>{bulletMultiDevice}</li>
            </ul>
            <button className={styles.getStartedButton} onClick={handleGetStarted}>
              {getStartedLabel}
            </button>
          </div>
          <div className={styles.highlightMedia}>
            <picture>
              <source
                media="(max-width: 768px)"
                srcSet={getImage("landing_gdk_screen_mobile", ImageType.Png)}
              />
              <img
                className={styles.highlightImage}
                src={getImage("landing_gdk_screen_desktop", ImageType.Png)}
                alt={gdkImageAlt}
              />
            </picture>
          </div>
        </div>
        <div className={styles.featureGrid}>
          <Feature title={enginesTitle} description={enginesDescription} />
          <Feature title={optimizeTitle} description={optimizeDescription} />
        </div>
      </div>
    </section>
  );
};
